import { makeAutoObservable, runInAction } from 'mobx';
import apiHandler from '../handlers/ApiHandler';

class UserStore {
    users = [];
    isLoading = false;
    error = null;
    user = null;

    constructor() {
        makeAutoObservable(this);
    }

    fetchUsers = async () => {
        this.isLoading = true;
        this.error = null;
        try {
            const response = await apiHandler.get('/users');
            runInAction(() => {
                this.user = response.data;
            });
        } catch (error) {
            runInAction(() => {
                this.error = error.message;
                console.error('Error fetching user:', error);
            });
        } finally {
            runInAction(() => {
                this.isLoading = false;
            });
        }
    }

    addUser = (user) => {
        this.users.push(user);
    }

    updateUser = async (user, userId) => {
        this.isLoading = true;
        this.error = null;
        try {
            const response = await apiHandler.put(`/users/${userId}`, user);
            runInAction(() => {
                this.user = response;
            });
        } catch (error) {
            runInAction(() => {
                this.error = error.message;
                console.error('Error saving user:', error);
            });
            throw error;
        } finally {
            runInAction(() => {
                this.isLoading = false;
            });
        }
    }

    fetchMyUser = async () => {
        this.isLoading = true;
        this.error = null;
        try {
            const response = await apiHandler.get(`/users/me`);
            runInAction(() => {
                this.user = response;
            });
        } catch (error) {
            runInAction(() => {
                this.error = error.message;
                console.error('Error fetching user by ID:', error);
            });
        } finally {
            runInAction(() => {
                this.isLoading = false;
                return;
            });
        }
    }

    clearError = () => {
        this.error = null;
    }

    clearUser = () => {
        this.user = null;
    }

    get userName() {
        return this.user ? this.user.name : '';
    }
}

export default new UserStore();
